import {CardEnum, CardTypeEnum, TurnState} from '@colonist/game-states'

export enum CardClickPopupType {
    None,
    NormalClick,
    TradeWindow,
    InformationPopup,
    ConfirmationPopup,
}

export interface BaseCardData {
    readonly cardEnum: CardEnum
    readonly cardTypeEnum: CardTypeEnum
    readonly isCardBack: boolean
    readonly clickPopupType: CardClickPopupType
    readonly allowableTurnStates: readonly TurnState[] | undefined
}
